import * as ngCore from '@angular/core'
import { AdaptiveCard, SubmitAction } from 'adaptivecards'

/**
 * Renders an {@link https://adaptivecards.io/ AdaptiveCard}
 *
 * @see {@link https://adaptivecards.io/explorer/ AdaptiveCard Schema}
 * @example
 * <atn-ds-adaptive-card
 *   [payload]="adaptiveCardPayload"
 *   (submit)="onSubmit($event)" />
 */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  selector: 'atn-ds-adaptive-card',
  standalone: true,
  styleUrls: ['./adaptive-card.component.scss'],
  templateUrl: './adaptive-card.component.html',
})
export class AtnDsAdaptiveCardComponent {
  public readonly adaptiveCard = new AdaptiveCard()

  @ngCore.ViewChild('adaptiveCard')
  public readonly adaptiveCardElementRef?: ngCore.ElementRef

  public readonly payloadSg = ngCore.input.required({
    alias: 'payload',
  })

  private readonly _renderPayload = ngCore.effect(() => {
    const payload = this.payloadSg()
    this.adaptiveCard.parse(payload)
    const content = this.adaptiveCard.render()
    if (content) {
      // Writes the rendered adaptive card to the DOM
      ;(
        this.adaptiveCardElementRef?.nativeElement as HTMLElement | undefined
      )?.replaceWith(content)
    }
  })

  public readonly submitEmitter = ngCore.output<object | undefined>({
    alias: 'submit',
  })

  constructor() {
    // Register action listener for submit actions
    this.adaptiveCard.onExecuteAction = action => {
      if (action instanceof SubmitAction) {
        this.submitEmitter.emit(action.data)
      }
    }
  }
}
